import flatten from 'lodash/flatten';
import {
  CmsContentTypes,
  CmsMemory,
  CmsPhase
} from '../integrations/contentful/types';
import { IconName } from '../components/common/Icon';

export function determineIconForMemoryPhase(
  phase: CmsPhase,
  isFirstPhase: boolean,
  shipTrip: boolean
): IconName {
  const type = phase.sys.contentType && phase.sys.contentType.sys.id;
  switch (type) {
    case CmsContentTypes.TravelPhase:
      // TODO: Should fetch this information from CmsPhase.
      if (shipTrip) {
        return isFirstPhase ? 'travel-ship-out' : 'travel-ship-in';
      }
      // TODO: Note this works OK only for flights which are first and last phases.
      // If the flights will ever be in some other than first or last phases this requires a different logic.
      return isFirstPhase ? 'travel-plane-out' : 'travel-plane-in';
    case CmsContentTypes.HotelPhase:
      return 'travel-hotel';
    case CmsContentTypes.ExperiencePhase:
    default:
      // TODO: Define different icons for different types of experience phases
      return 'travel-activity';
  }
}

export function isMemoryPhaseType(
  phase: CmsPhase,
  expectedType: CmsContentTypes
) {
  const type = phase.sys.contentType && phase.sys.contentType.sys.id;
  return type === expectedType;
}

export function extractExperiencePhasesFromMemories(memories: CmsMemory[]) {
  return flatten(
    memories.map((memory) => {
      return memory.fields.phases;
    })
  ).filter((phase) => {
    return isMemoryPhaseType(phase, CmsContentTypes.ExperiencePhase);
  });
}
